'use client';

import { useMemo } from 'react';
import { ACTIVITY_INFINITE_PAGE_SIZE, useInfiniteActivityByEvent } from '@/lib/api/history/hooks';
import { ActivityCard } from '@/lib/components/ActivityCard';
import { ActivityTable } from '@/lib/components/ActivityTable';

interface ActivitySectionProps {
  eventId: string;
}

export const ActivitySection = ({ eventId }: ActivitySectionProps) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteActivityByEvent(eventId, { size: ACTIVITY_INFINITE_PAGE_SIZE });

  const items = useMemo(() => {
    if (!data?.pages) return [];
    return data.pages.flatMap((page) => page.items);
  }, [data]);

  return (
    <>
      <div className="hidden min-[420px]:block">
        <ActivityTable
          items={items}
          isLoading={isLoading}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage ?? false}
          isFetchingNextPage={isFetchingNextPage}
        />
      </div>
      <div className="flex flex-col min-[420px]:hidden">
        <ActivityCard
          items={items}
          isLoading={isLoading}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage ?? false}
          isFetchingNextPage={isFetchingNextPage}
        />
      </div>
    </>
  );
};
